import RegisterShipmentCalculator from './registerShipmentCalculator';

export default RegisterShipmentCalculator;
